module.exports = __webpack_public_path__ + "img/Rectangle 674.533f82fc.png";